module.exports = __webpack_public_path__ + "static/img/labour-3.35f76b9.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/rescuelist/img/list/labour-3.png
// module id = aMtm
// module chunks = 1